
namespace Matrix.Data {
    @Serenity.Decorators.filterable()
    @Serenity.Decorators.registerClass()
    export class SecurityMatchRulesetGrid extends SiteEntityGrid<SecurityMatchRulesetRow, any> {
        protected getColumnsKey() { return 'Data.SecurityMatchRuleset'; }
        protected getDialogType() { return SecurityMatchRulesetDialog; }
        protected getIdProperty() { return SecurityMatchRulesetRow.idProperty; }
        protected getInsertPermission() { return SecurityMatchRulesetRow.insertPermission; }
        protected getLocalTextPrefix() { return SecurityMatchRulesetRow.localTextPrefix; }
        protected getService() { return SecurityMatchRulesetService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}